import { StyleSheet } from "react-native"
import { baseColors, basePadding, baseFontFamily, baseMarging } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white,
        paddingHorizontal: basePadding.paddingHorizontal,
        paddingVertical: basePadding.paddingVertical
    },
    content: {},
    header: { marginBottom: 20 },
    title: {
        fontSize: RFValue(22)
    },
    subTitle: {
        fontSize: RFValue(16)
    },
    item: {
        marginVertical: RFValue(10)
    },
    contentTitle: {
        color: baseColors.green.primary,
        marginBottom: baseMarging.marginBottom
    }
})

export default styles
